import { HeroSection } from './components/HeroSection';
import { MakersSection } from './components/MakersSection';
import { SeekersSection } from './components/SeekersSection';
import { ExperienceSection } from './components/ExperienceSection';
import { NFCRedirectSection } from './components/NFCRedirectSection';
import { ProfileSection } from './components/ProfileSection';
import { Footer } from './components/Footer';
import { BottomNav } from '../../components/feature/BottomNav';
import { Navbar } from './components/Navbar';
import { NodeSection } from './components/NodeSection';

export default function HomePage() {
  return (
    <div>
      <Navbar />
      <BottomNav />
      <HeroSection />
      <ExperienceSection />
      <SeekersSection />
      <MakersSection />
      <NodeSection />
      <NFCRedirectSection />
      <ProfileSection />
      <Footer />
    </div>
  );
}